import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const Wrapper = styled.div`
    flex-direction: column;
    width: 100%;
    padding: 12px 16px;
    row-gap: 4px;
    border-radius: ${BorderRadius.componentRadius};
    background-color: ${COLORS.BgSurface};
`;

export const TextBlock = styled.div`
    flex-wrap: nowrap;
    justify-content: space-between;
    column-gap: 4px;
`;

export const ReminderWrapper = styled.div`
    max-width: 110px;
    text-align: right;
`;

export const ProgressBarWrapper = styled.div`
    width: 100%;
    align-items: center;
    padding: 6px 0;
`;

export const ProgressBar = styled.div`
    position: relative;
    width: 100%;
    height: 4px;
    border-radius: ${BorderRadius.labelRadius};
    background: linear-gradient(90deg, ${COLORS.LabelsText_2} 81%, ${COLORS.LabelsBg_2} 81%);

    &:after {
        content: '';
        position: absolute;
        top: -4px;
        right: 18%;
        width: 12px;
        height: 12px;
        border-radius: ${BorderRadius.alert};
        background-color: ${COLORS.LabelsText_2};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        background: linear-gradient(90deg, ${COLORS.LabelsText_2} 86%, ${COLORS.LabelsBg_2} 86%);

        &:after {
            right: 13%;
        }
    }
`;
